import React from 'react';
import { Heart, Info } from 'lucide-react';

export const FavoriteHeart = ({ bookId, active, onToggle, size = 18, style }) => (
  <button type="button" data-testid={`favorite-btn-${bookId}`} aria-pressed={active}
    title={active ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
    onClick={(e) => { e.stopPropagation(); onToggle(bookId); }}
    style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 4, display: 'inline-flex', alignItems: 'center',
      justifyContent: 'center', transition: 'transform 0.15s ease', ...style }}
    onMouseDown={(e) => { e.currentTarget.style.transform = 'scale(0.85)'; }}
    onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
    <Heart style={{ width: size, height: size, color: active ? '#e53e3e' : '#a0aec0', fill: active ? '#e53e3e' : 'transparent', transition: 'fill 0.2s ease, color 0.2s ease' }} />
  </button>
);

export const BookInfoButton = ({ bookId, onOpen, size = 18, color = '#a0aec0' }) => (
  <button type="button" data-testid={`book-more-info-${bookId}`} title="Mais informações" aria-label="Mais informações"
    onClick={(e) => { e.stopPropagation(); onOpen(); }}
    style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 4, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', transition: 'transform 0.15s ease' }}
    onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.12)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
    <Info style={{ width: size, height: size, color }} />
  </button>
);
